<template>
    <el-dialog
        custom-class="bm-buy-dialog"
        :visible.sync="visible"
        width="910px"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <iframe frameborder="0" style="margin: 0 auto;" v-if="visible" :src="src" width="910" height="670">

        </iframe>
    </el-dialog>
</template>
<script>
import storage from "@/utils/storage";

export default {
    props: ['show', 'buy','level'],
    computed: {
        visible: function () {
            return !!this.show;
        },
        src: function () {
            let host = process.env.NODE_ENV === 'development' ? 'http://localhost:8081' : 'https://godeyes.bigemap.com//pro_buy/';
            let token = storage.token();
            let buy=this.buy||{net_id:""};
            return [host, '#/login?token=', token, '&auth_level=',this.level||2,'&net_id='+buy.net_id,'&type=web&_t1=', Math.random()].join('');
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
}
</script>
<style scoped lang="less">

</style>